import React from 'react'

const Playicon = ({fill = "white"}) => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill={fill}>
            <path d="M8 5v14l11-7z" />
        </svg>
    )
}

export default Playicon
